<template>
  <LayoutFull>
    <PartnerHeader />
    <LoginRegisterForm @loggedIn="onLoggedIn" />
  </LayoutFull>
</template>

<script>
import LayoutFull from '@/router/layouts/Full.vue'
import PartnerHeader from '@/components/user/PartnerHeader'
import LoginRegisterForm from '@/components/user/LoginRegisterForm'
import authService from '@/services/authService'
import drApiStarlingService from '@/services/starlingService'
import { fetchStarlingData } from '@/lib/starling'

export default {
  components: {
    LayoutFull,
    PartnerHeader,
    LoginRegisterForm,
  },
  methods: {
    async onLoggedIn () {
      const state = this.$store.getters['user/loginFlow'].state

      // Automatically send an auth code to Starling so they can access our data
      if (state) {
        await authService.post('/codes', { partner: 'starling', state: this.$store.getters['user/loginFlow'].state })
      }

      // Check the status of this user's auth with Starling, if we don't have access
      // we'll redirect to get auth, otherwise get them straight into the quote
      // process.
      try {
        await fetchStarlingData()
        this.$store.commit('shared/setLoading', false, { root: true })
        this.$router.push('/')
      } catch (err) {
        const { data } = await drApiStarlingService.get(`/redirect?state=${state}`)
        this.$store.commit('shared/setLoading', false, { root: true })
        window.location.replace(data.url)
      }
    },
  },
}
</script>
